import React from 'react'
import { useFormContext } from "react-hook-form";
import './../Form.css'

const RadioGroup = props => {
    const { validation, defaultValue, ...inputProps } = props;
    const { id, label, options } = inputProps;
    const formBinding = useFormContext();
    const { register, watch, setValue,  getValues, formState: { errors } } = formBinding;
    const [checkedValue, setCheckedValue] = React.useState(getValues(id));
    const updateRadioValue = (value) => {
        setValue(id, value);
        setCheckedValue(value);
        errors[id]='';
    }
    watch((data, { name }) => {
        if(name === id){
            setCheckedValue(data[id]);
        }
    });
    return (
        <>
            { options&&options.length>0&&
                <div className="form-element">
                    {label && <label>{label}</label>}
                    <div className="radio-group">
                        {options.map(({value, label}) => <div className="radio-item" style={{width:"50%"}} key={id+"-"+value}>
                            <input type="radio" id={value} name={id + '-radio'} value={value}
                                   checked={value === checkedValue}
                                   onChange={() => updateRadioValue(value)}/>
                            <span>{label}</span>
                        </div>)}
                    </div>
                    <input id={id} type="hidden" {...register(id, validation)}/>
                    {errors[id] && <p className="input-error">{errors[id].message}</p>}
                </div>
            }
        </>
    )
}
export default RadioGroup
